export type TimeWindow = { s0: number; rng: number };

export function clampWindow(view: TimeWindow, session: TimeWindow): TimeWindow {
  const rng = Math.min(session.rng, Math.max(Math.min(1, session.rng), view.rng));
  return { s0: Math.max(session.s0, Math.min(view.s0, session.s0 + session.rng - rng)), rng };
}

export function zoomWindow(view: TimeWindow, session: TimeWindow, factor: number, anchor = 0.5) {
  const rng = Math.min(session.rng, Math.max(Math.min(1, session.rng), view.rng * factor));
  return clampWindow({ s0: view.s0 + (view.rng - rng) * anchor, rng }, session);
}

// Reserve a full label's width at both edges, including multi-day suffixes.
export function timelineTicks(view: TimeWindow, width: number) {
  const spacing = 110;
  const desired = (view.rng * spacing) / Math.max(width, spacing);
  const interval =
    [1, 2, 5, 10, 15, 30, 60, 120, 180, 360, 720, 1440].find(n => n >= desired) ??
    Math.ceil(desired / 1440) * 1440;
  const margin = (view.rng * 50) / Math.max(width, 1);
  const labelFor = (time: number) => {
    const day = Math.floor(time / 1440);
    const minute = ((time % 1440) + 1440) % 1440;
    return `${Math.floor(minute / 60)}:${String(minute % 60).padStart(2, "0")}${day ? ` (${day > 0 ? "+" : ""}${day}d)` : ""}`;
  };
  const ticks: { label: string; pos: number }[] = [];
  for (
    let time = Math.ceil((view.s0 + margin) / interval) * interval;
    time <= view.s0 + view.rng - margin;
    time += interval
  ) {
    ticks.push({
      label: labelFor(time),
      pos: ((time - view.s0) / view.rng) * 100,
    });
  }
  if (ticks.length === 0 && width >= 80)
    ticks.push({ label: labelFor(Math.round(view.s0 + view.rng / 2)), pos: 50 });
  return ticks;
}
